import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <p><span className="subtiltereg">Decision making style</span>
                                            </p>
                                            <p>If you answered (a) you may make your decisions using ‘gut
                                                reaction’ and emotion. You may also
                                                try to think how other people will react emotionally. You
                                                will try to understand others’ reactions to
                                                your decision, and take this into account when making a
                                                judgement call. You may need to ensure
                                                that you focus on the logic and rationale behind the
                                                decision, especially when decisions involve
                                                more analytical types.</p>
                                            <p>If you answered (b) you may make your decision by focusing on
                                                the task that needs to be
                                                completed, the process that needs to be followed and the
                                                deliverable outcomes. You are unlikely
                                                to be overly focused on the feelings or emotions of the
                                                individuals involved if they are likely to
                                                impede progress. You run the risk of not considering other
                                                people’s feelings when making
                                                decisions and you should try to factor this into your
                                                decision making.</p>
                                            <div className="lightgreencontentbg keyquestionpad">


                                                <ol className="testclass_numeric"
                                                    style={{counterReset: 'item 4'}}>
                                                    <li><p className="further_info_content"><span
                                                        className="green"><strong>Neuroticism</strong></span>
                                                    </p></li>
                                                </ol>

                                                <p className="further_info_content pad-sept"><span
                                                    className="pad-bot">Are you more</span></p>
                                                <p><span className="green"
                                                         style={{paddingRight:'10px'}}><strong>a)</strong> </span> Calm,
                                                    consistent under pressure, confident in own opinions?
                                                </p>


                                                <div style={{paddingBottom: '13px'}}><span
                                                    className="subtiltereg">OR</span></div>
                                                <p><span className="green"
                                                         style={{paddingRight:'10px'}}><strong>b)</strong> </span> Anxious,
                                                    emotionally expressive, reflective, somewhat self
                                                    critical?</p>

                                            </div>
                                            <p><span className="subtiltereg">Decision making style</span>
                                            </p>
                                            <p>If you answered (a) your decision making style indicates that
                                                you are likely to think positively. It is
                                                this optimistic viewpoint that helps you to see all the
                                                benefits of the decision and the value in it.
                                                It can help you to keep going when everything looks gloomy
                                                or difficult. You need to ensure that
                                                you are being realistic and not overly optimistic as well as
                                                considering the potential risks
                                                and threats.</p>
                                            <p>If you answered (b) your decision making style is likely to
                                                identify all of the bad points of the
                                                decision. Look at it cautiously and defensively. Try to see
                                                why it might not work. This is important
                                                because it highlights the weak points in a plan. It allows
                                                you to eliminate them, alter them, or
                                                prepare contingency plans to counter them. It helps to make
                                                your plans ‘tougher’ and more
                                                resilient. It can also help you to spot fatal flaws and
                                                risks before you embark on a course of
                                                action. You need to make sure that you are also considering
                                                the potential opportunities and
                                                benefits as you may overlook these in your approach.</p>


                                            <div className="border_subtitle">Step three</div>
                                            <p>Now look at the information on the decision making styles
                                                that DO NOT match with your
                                                personality responses – these are where you may have
                                                decision making ‘blind spots’. In the table
                                                on the next page, complete the first column ‘Potential
                                                decision making blind spot’ by noting the
                                                styles that you feel don’t represent your normal approach to
                                                decision making. Do this for each of
                                                the five decision making styles described above.</p>

                                            <div className="border_subtitle">Step four</div>
                                            <p>When next making a judgement call or important decision –
                                                start by following your usual decision
                                                making process. However, before you make your final
                                                decision, look through your table and
                                                consider the decision and its outcome from the ‘blind spots’
                                                or perspectives you would not
                                                normally consider. in the table, make a note of what you
                                                could do, or what you could consider,
                                                from each perspective and write them in the columns marked
                                                ‘Decision 1’, ‘Decision 2’ and
                                                ‘Decision 3’.</p>
                                            <p>Add this information into your decision making process. This
                                                will allow you to have increased
                                                confidence in your final decision.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}